<template>
  <div id="apt-stats">
    <div class="page-header">
      <div class="title">통계 분석</div>
      <div class="subtitle">실거래 데이터를 조건별로 집계하고 두 조건을 나란히 비교합니다</div>
    </div>

    <!-- 표시 항목 설정 -->
    <div class="metric-bar">
      <span class="mb-label">표시 항목</span>
      <label v-for="m in metricDefs" :key="m.key" class="mb-chip" :class="{ on: metrics[m.key] }">
        <input type="checkbox" v-model="metrics[m.key]" />
        {{ m.label }}
      </label>
    </div>

    <!-- 패널 -->
    <div class="panels" :class="{ single: !compare }">
      <StatsPanel
        :gu-options="guOptions"
        :metrics="metrics"
        accent="#4a9fe0"
        :initial="{ sggCd: '11680', minPy: 24, maxPy: 27 }"
        @stats="panelAStats = $event"
      />
      <StatsPanel
        v-if="compare"
        :gu-options="guOptions"
        :metrics="metrics"
        accent="#e0a53a"
        :removable="true"
        :initial="{ sggCd: '11230', minPy: 24, maxPy: 27 }"
        :compare-base="panelAStats"
        @remove="compare = false"
      />
      <button v-else class="add-compare" @click="compare = true">
        <span class="plus">+</span>
        <span>비교 조건 추가</span>
        <span class="ac-hint">다른 지역·평형과 나란히 비교</span>
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import UtilMixin from "@/common/mixins/UtilMixin";
import StatsPanel from "../components/StatsPanel.vue";

export default defineComponent({
  name: "AptStatsView",
  components: { StatsPanel },
  mixins: [UtilMixin],
  data() {
    return {
      compare: false,
      panelAStats: null as Record<string, number> | null,
      metricDefs: [
        { key: "count", label: "거래 건수" },
        { key: "avg", label: "평균 거래가" },
        { key: "median", label: "중앙값" },
        { key: "perPyeong", label: "평단가" },
        { key: "max", label: "최고가" },
        { key: "min", label: "최저가" },
        { key: "area", label: "평균 면적" },
      ],
      metrics: {
        count: true,
        avg: true,
        median: true,
        perPyeong: true,
        max: true,
        min: true,
        area: false,
      } as Record<string, boolean>,
      guOptions: {
        "11110": "종로구", "11140": "중구", "11170": "용산구", "11200": "성동구",
        "11215": "광진구", "11230": "동대문구", "11260": "중랑구", "11290": "성북구",
        "11305": "강북구", "11320": "도봉구", "11350": "노원구", "11380": "은평구",
        "11410": "서대문구", "11440": "마포구", "11470": "양천구", "11500": "강서구",
        "11530": "구로구", "11545": "금천구", "11560": "영등포구", "11590": "동작구",
        "11620": "관악구", "11650": "서초구", "11680": "강남구", "11710": "송파구",
        "11740": "강동구",
      } as Record<string, string>,
    };
  },
});
</script>
